"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[53707],{

/***/ 53707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ CardProcessor; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function CardProcessor() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "mt-10 lg:mt-16",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "text-center text-xl font-bold lg:text-3xl mb-8 lg:mb-10",
                children: "What Is a Credit Card Processor?"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-center font-light text-sm lg:text-base",
                children: "A credit card processor facilitates transactions between merchants and customers by transmitting data and verifying card validity. They act as a middleman between the card network, issuing bank, acquiring bank, and parties involved in the payment process. The processor charges a fee, usually a percentage of the transaction, and ensures the transaction's security."
            })
        ]
    });
}


/***/ })

}]);